import { Space, Table, Typography } from 'antd';
import { Optional } from '../Shared';
import { defaultIfEmpty } from './util';
import type { NoteShiftChange } from '../../hooks/types';

const { Text } = Typography;

/**
 * Renders the content of a note, with its  "changes", if applicable.
 */
export const ShiftNoteContent: React.FC<{
  readonly content: string | undefined;
  readonly changes: readonly NoteShiftChange[];
  readonly date?: string;
}> = ({ content, changes, date }) => {
  const hasChanges = changes.length > 0;
  const margin = { marginBottom: '10px' };
  return (
    <Space direction="vertical" style={{ display: 'flex' }}>
      {date === undefined ? (
        <></>
      ) : (
        <Text type="secondary" style={margin}>
          {`[On Shift: ${date}]`}
        </Text>
      )}

      <Optional show={hasChanges}>
        <em style={margin}>Shift Changed</em>
      </Optional>

      <Optional show={content !== undefined}>
        <Optional show={hasChanges}>
          <Text strong style={margin}>
            Reason for Change:
          </Text>
        </Optional>

        <div style={{ whiteSpace: 'pre-wrap', ...margin }}>{content}</div>
      </Optional>

      <Optional show={hasChanges}>
        <Table
          size="small"
          pagination={false}
          rowKey={(r) => r.field}
          dataSource={changes}
          style={{ flexGrow: 1 }}
          columns={[
            { title: 'Field', dataIndex: 'field' },
            {
              title: 'From',
              dataIndex: 'from',
              render: (v: NoteShiftChange['from']) => defaultIfEmpty(v),
            },
            {
              title: 'To',
              dataIndex: 'to',
              render: (v: NoteShiftChange['to']) => defaultIfEmpty(v),
            },
          ]}
        />
      </Optional>
    </Space>
  );
};
